import type { Release } from '../releases';

export default {
  id: '2026-11-03-help-related-articles',
  at: '2026-11-03T05:58:00Z',
  title: '«Статьи по теме» в «Помощи» на любой карточке',
  modules: [],
  items: [
    'В панели «Помощь» появился блок «Статьи по теме»: статьи базы знаний, связанные с открытой записью — проектом, замечанием, сметой или документом нормативной базы, — и с разделом портала. Статьи к самой записи показаны первыми.',
    'Видны только опубликованные статьи, открытые вашей роли. Связать статью с записью или разделом можно в карточке статьи базы знаний.',
  ],
  why: 'Регламенты и уроки проектов лежали в базе знаний отдельно, и в карточке проекта или замечания их не было видно — нужное приходилось искать вручную.',
  link: '/kb',
} satisfies Release;
